var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg0MyHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4L4 14.3244L5.22844 15.7258L6.352 14.7591V23.8827C6.352 25.4178 7.61244 26.6667 9.16222 26.6667H14.4076V17.572H17.6862V26.6667H22.8382C24.3876 26.6667 25.648 25.4178 25.648 23.8827V14.7591L26.7716 15.7258L28 14.3244L16 4ZM23.7747 23.8827C23.7747 24.3942 23.3547 24.8107 22.8382 24.8107H19.5596V15.7156H12.5342V24.8102H9.16178C8.64533 24.8102 8.22533 24.3938 8.22533 23.8822V13.1476L16 6.45867L23.7747 13.1476V23.8827Z",
    fill: "#F1CA65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg0MyHome);
export default __webpack_public_path__ + "static/media/0-MyHome.1beb5ccfe397ef663011952e185942c5.svg";
export { ForwardRef as ReactComponent };